export default {
  default: 'Une erreur est survenue.',
  cantDelete: 'La suppression a échoué.',
  'api.error.unique_email': 'Cette adresse email est déjà utilisée.',
  'api.error.property_password_complexity': 'Le mot de passe ne respecte pas les règles de complexité.',
  'Invalid credentials.': 'L’adresse email ou le mot de passe est incorrect.',
  'Invalid credentials': 'L’adresse email ou le mot de passe est incorrect.',
};
